import React from 'react'

import { Button } from 'react-admin'

import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconCancel from '@mui/icons-material/Cancel'
import IconContentAdd from '@mui/icons-material/Add'
import { DocumentNode, useMutation } from '@apollo/client'
import { Form, Input } from 'antd'

export interface CreateModalProps extends DialogProps {
  title: string
  createLabel?: string
  formName?: string

  actions?: React.ReactNode

  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>

  onSuccess: (...args: any[]) => void
  onFailure: (err: any) => void
  query: DocumentNode
}

export const CreateModal: React.FC<CreateModalProps> = (props) => {
  const {
    title = '// UNTITLED MODAL //',
    formName = title
      .toLowerCase()
      .replace(/[^A-Z- ]/g, '')
      .replace(' ', '-'),
    actions,
    createLabel = 'Create',
    open,
    setOpen,
    onSuccess: onSuccessProp,
    onFailure,
    query,
    ...restProps
  } = props

  const [form] = Form.useForm()

  const onSuccess = (values) => {
    form.resetFields()
    onSuccessProp(values)
  }

  const [create] = useMutation(query, {
    onCompleted: onSuccess,
    onError: onFailure,
  })

  const onSubmit = (values) => {
    create({ variables: values })
  }

  React.useEffect(() => {
    if (!open)
      // reset form when modal closes
      form.resetFields()
  }, [open])

  return (
    <Dialog fullWidth open={open} aria-label={title} {...restProps}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Form name={formName} form={form} onFinish={onSubmit}>
          {props.children}

          <div style={{ display: 'flex' }}>
            {actions ?? (
              <>
                <Button
                  style={{ marginLeft: 'auto' }}
                  label="ra.action.cancel"
                  onClick={() => {
                    setOpen(false)
                  }}
                >
                  <IconCancel />
                </Button>
                <Button type="submit" label={createLabel}>
                  <IconContentAdd />
                </Button>
              </>
            )}
          </div>
        </Form>
      </DialogContent>
    </Dialog>
  )
}
